import Enum from '../../utils/enum';

const Networks = new Enum(['PATIENT', 'PROVIDER'] as const);

export default Networks;
